import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { ActiveBetsInfoType } from "@tvg/sh-lib-my-bets/utils/types";
import { useSelector } from "react-redux";
import { getDeletedBets } from "@tvg/sh-lib-my-bets/redux/selectors";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { onFetchMore } from "@tvg/sh-lib-my-bets/graphql/behgOptions.graph";
import queryHelper from "../graphql/behgOptions.graph";
import { GET_GROUP_WAGERS_MY_BETS } from "../graphql/queries/GroupWagers";
import { GroupWagersQueryProps, WagerHistoryData } from "../types";

const useGetGroupWagers = ({
  accountNumber,
  behgClient,
  selectedSettledTab,
  selectedTab,
  hasPagination,
  wagersPerPage
}: GroupWagersQueryProps) => {
  const deletedBets: string[] = useSelector(getDeletedBets);

  const [queryBets, setQueryBets] = useState<ActiveBetsInfoType>({
    bets: [],
    totalBets: 0,
    totalAmount: 0
  });

  const {
    data,
    loading: isLoadingBehg,
    subscribeToMore,
    fetchMore
  } = useQuery<WagerHistoryData>(
    GET_GROUP_WAGERS_MY_BETS,
    queryHelper.apolloOptions({
      accountNumber,
      behgClient,
      selectedSettledTab,
      selectedTab,
      hasPagination,
      wagersPerPage
    })
  );

  const onFetchMoreCallback = (
    callback: UnaryFn<boolean, void>,
    page: number
  ) => {
    onFetchMore(
      // @ts-ignore -> Only to keep compatible with sh-lib-my-bets
      fetchMore,
      page,
      callback,
      wagersPerPage
    );
  };

  useEffect(() => {
    if (data && !isLoadingBehg) {
      setQueryBets(
        queryHelper.getActiveBetsInfo(
          data,
          selectedSettledTab,
          selectedTab,
          deletedBets
        )
      );
    }
  }, [data, isLoadingBehg, selectedTab]);

  return {
    queryBets,
    isLoadingBehg,
    subscribeToMore,
    fetchMore: onFetchMoreCallback
  };
};

export default useGetGroupWagers;
